import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CurriculumTreeYearInterface } from '../../+models';
import { CurriculumTreeYearsActions, CurriculumTreeYearsActionTypes } from './curriculum-tree-year.actions';

export const NAME = 'curriculumTreeYears';

export interface State extends EntityState<CurriculumTreeYearInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<CurriculumTreeYearInterface> = createEntityAdapter<CurriculumTreeYearInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: CurriculumTreeYearsActions): State {
  switch (action.type) {
    case CurriculumTreeYearsActionTypes.AddCurriculumTreeYear: {
      return adapter.addOne(action.payload.curriculumTreeYear, state);
    }

    case CurriculumTreeYearsActionTypes.UpsertCurriculumTreeYear: {
      return adapter.upsertOne(action.payload.curriculumTreeYear, state);
    }

    case CurriculumTreeYearsActionTypes.AddCurriculumTreeYears: {
      return adapter.addMany(action.payload.curriculumTreeYears, state);
    }

    case CurriculumTreeYearsActionTypes.UpsertCurriculumTreeYears: {
      return adapter.upsertMany(action.payload.curriculumTreeYears, state);
    }

    case CurriculumTreeYearsActionTypes.UpdateCurriculumTreeYear: {
      return adapter.updateOne(action.payload.curriculumTreeYear, state);
    }

    case CurriculumTreeYearsActionTypes.UpdateCurriculumTreeYears: {
      return adapter.updateMany(action.payload.curriculumTreeYears, state);
    }

    case CurriculumTreeYearsActionTypes.DeleteCurriculumTreeYear: {
      return adapter.removeOne(action.payload.id, state);
    }

    case CurriculumTreeYearsActionTypes.DeleteCurriculumTreeYears: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case CurriculumTreeYearsActionTypes.CurriculumTreeYearsLoaded: {
      return adapter.setAll(action.payload.curriculumTreeYears, {
        ...state,
        loaded: true,
      });
    }

    case CurriculumTreeYearsActionTypes.CurriculumTreeYearsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case CurriculumTreeYearsActionTypes.ClearCurriculumTreeYears: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
